import { render, staticRenderFns } from "./mapkind-table.vue?vue&type=template&id=3f84194c"
import script from "./mapkind-table.vue?vue&type=script&lang=js"
export * from "./mapkind-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f84194c')) {
      api.createRecord('3f84194c', component.options)
    } else {
      api.reload('3f84194c', component.options)
    }
    module.hot.accept("./mapkind-table.vue?vue&type=template&id=3f84194c", function () {
      api.rerender('3f84194c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mutils/views/map-save-action/mapkind-table.vue"
export default component.exports